<template>
  <div>
    <page-header title="Users and Groups" breadcrumb="Dashboard > Users and Groups" />
    <div class="flex justify-between mt-12 mb-2">
      <div class="flex">
        <div class="tab-item" :class="{ active: currentTab == 'users' }" @click="currentTab = 'users'">
          <p>Users</p>
        </div>
        <div hidden class="tab-item " :class="{ active: currentTab == 'groups' }" @click="currentTab = 'groups'">
          <p>Groups</p>
        </div>
        <div class="tab-item" :class="{ active: currentTab == 'deactivated' }" @click="currentTab = 'deactivated'">
          <p>Deactivated</p>
        </div>
      </div>
      <div class="flex" v-if="currentTab != 'users'">
        <div class="mr-2  p-2 px-3 filter cursor-pointer hover:shadow-sm " :class="{ 'shadow-sm': sortList }"
          @click="sortList = !sortList">
          <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
        </div>
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50">
            <search-icon />
          </span>
          <input type="text" class="table__search-input" placeholder="Search..." v-model="query" />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>
    </div>
    <hr />
    <!-- <keep-alive> -->
    <component :is="currentTab"></component>
    <!-- </keep-alive> -->
  </div>
</template> 

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Deactivated from "@/components/3pl/Users/Tabs/Deactivated";
import Groups from "@/components/3pl/Users/Tabs/Groups";
import Users from "@/components/3pl/Users/Tabs/Users";
export default {
  components: {
    Deactivated,
    Groups,
    Users,
    PageHeader
  },
  data() {
    return {
      currentTab: "users",
      query: '',
      count: {},
      sortList: false
    };
  },
  watch: {
    currentTab(val) {
      this.$store.dispatch("setCurrentUsersAndGroupTab", val);
    },
    query(val) {
      this.$store.dispatch("setUsersAndGroupQuery", val);
    },
    sortList() {
      this.$store.dispatch("setUsersAndGroupSortList", this.sortList);
    }
  },
  mounted() {
    this.currentTab='users'
    this.$store.dispatch("setUsersAndGroupQuery", "");
    const currentTab = this.$store.getters.currentUserAndGroupsTab;
    if (currentTab) {
      this.currentTab = currentTab;
    }
  },
  methods: {
    showDeleteModal(payload) {
      this.itemToDelete = payload[0];
      this.selectedId = payload[1];
      this.isDeleteModal = true;
    },
    async deleteUser() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteUser(this.selectedId);
        this.onDeleteUser(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteGroup() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteGroup(this.selectedId);
        this.onDeleteGroup(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    onDeleteUser(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      this.$refs.usersDataTable.getAllUsers();
      this.generateToast("User successfully deleted!", "success");
    },
    onDeleteGroup(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      // this.fetchGroups = true;
      this.$refs.groupsDataTable.getAllGroups();
      this.generateToast("Group successfully deleted!", "success");
    },
    deleteItem() {
      if (this.itemToDelete == "User") {
        this.deleteUser();
      } else if (this.itemToDelete == "Group") {
        this.deleteGroup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #FCC210;
    font-weight: bold;
  }
}
</style>